
function ckeditor() {

	const DATA = {
		userUploadUrl: null
	}

	function init(opt) {
		CKEDITOR.timestamp = opt.timestamp
		DATA.userUploadUrl = opt.userUploadUrl

		if ( !CKEDITOR.env.ie || CKEDITOR.env.version > 7 ) {
			CKEDITOR.env.isCompatible = true;
		}

		CKEDITOR.on('dialogDefinition', function(ev) {
			const dialogName = ev.data.name;
			const dialogDefinition = ev.data.definition;

			if ( dialogName == 'table' || dialogName == 'tableProperties' ) {
				const infoTab  = dialogDefinition.getContents( 'info' );
				infoTab.get('txtCellSpace')['default'] = '0'
				infoTab.get('txtCellPad')['default'] = '0'
				// infoTab.remove('txtBorder');
				// infoTab.remove('txtWidth');
				// infoTab.remove('txtHeight');
				// infoTab.remove('txtCellSpace');
				// infoTab.remove('txtCellPad');
				// infoTab.remove('txtCaption');
				// infoTab.remove('txtSummary');
				// infoTab.remove('selHeaders');

				// dialogDefinition.removeContents('advanced');
			}

			// if ( dialogName == 'image2') {
				// dialogDefinition.removeContents('advanced');
			// }
		});

		// $_GP.geogebra.init(opt)
	}

	function getData(key) {
		return DATA[key] ? DATA[key] : false
	}

	function startEditors(ids, options) {
		const editors = ids.reduce((acc, id)=> {
			acc = acc || []
			acc[id] = CKEDITOR.replace(id, options);
			return acc
		}, {})

		function addToken(ev) {
			ev.data.requestData[$_GP.CSRF_TOKEN] = Cookies.get($_GP.CSRF_COOKIE)
		}

		for (const editor in editors) {
			// CKEDITOR.instances[editor].on('fileUploadRequest', addToken)
			editors[editor].on('fileUploadRequest', addToken)
		}

		return editors
	}

	function destroyEditors(ids=[]) {
		ids.forEach((id)=> {
			if (CKEDITOR.instances[id]) CKEDITOR.instances[id].destroy()
		})
	}

	// Methods
	function base(ids=[], opt={}) {
		const options = $.extend({}, opt);
		const editors = startEditors(ids, options)
		return editors;
	}

	function wiris(ids=[], opt={}) {
		const options = $.extend({ toolbar:'wiris'}, opt);
		const editors = startEditors(ids, options)
		return editors;
	}

	return { init, base, wiris, getData, destroyEditors }
}

function geogebra() {

	let WINDOW_IS_LOAD = false
	let GEOGEBRA_STATE = false
	let CK_EDITOR      = false
	let CK_ELM         = false
	let GGB_APP        = false
	let GGB_APP_HEIGHT = null
	let $modalGeogebra = false

	const ggbOptions = {
		// https://wiki.geogebra.org/en/Reference:GeoGebra_App_Parameters
		// geometry from alphamat
		// now is grphing and 3d
		appName: 'geometry',
		// width: 1140,
		// height: 400,
		showToolBar: true,
		showAlgebraInput: true,
		showMenuBar: true,
		enableFileFeatures: true,
		showResetIcon: true,
		// ggbBase64: initBase64
	}

	const ggbDomId    = 'ggb-modal';
	const b64PngStart = 'data:image/png;base64,';

	const $body = $('body')

	function getGeogebraImg(b64Img, b64Ggb) {
		if (!b64Img || !b64Ggb) return false
		const appHeight = GGB_APP_HEIGHT ? ('data-app-height="'+ GGB_APP_HEIGHT +'"') : ''
		return `<img class="ckeditor_geogebra_img" data-app-name="${ggbOptions.appName}" ${appHeight} src="${b64PngStart + b64Img}" data-ggb="${b64Ggb}" alt="ggb">`
	}

	function initModal() {
		$modalGeogebra = $(''+
			'<div class="modal modal-geogebra fade">'+
				'<div class="modal-dialog">'+
					'<div class="modal-content">'+
						'<div class="modal-body-geogebra"><div id="resizable-ggb"><div id="'+ ggbDomId +'"></div></div></div>'+
						'<div class="modal-body">'+
							'<button class="btn btn-brand modal-geogebra-btn" type="button">OK</button>'+
							'<button class="btn" data-dismiss="modal" type="button">Cancelar</button>'+
						'</div>'+
					'</div>'+
				'</div>'+
			'</div>'
		)

		const $modalResizable = $modalGeogebra.find('#resizable-ggb')
		const $modalBtnInsert = $modalGeogebra.find('.modal-geogebra-btn')
		const $modalGgb       = $modalGeogebra.find('#'+ ggbDomId)

		$body.append($modalGeogebra)

		$modalBtnInsert.on('click', function() {

			if (GEOGEBRA_STATE === 'create') {
				const b64Img = ggbApplet.getPNGBase64(1, true, 72);
				const b64Ggb = ggbApplet.getBase64();
				const geoImage = getGeogebraImg(b64Img, b64Ggb)

				if (geoImage) {
					CK_EDITOR.insertHtml(geoImage)
				}

				$modalGeogebra.modal('hide')
				return
			}

			if (GEOGEBRA_STATE === 'edit') {
				const b64Img = ggbApplet.getPNGBase64(1, true, 72);
				const b64Ggb = ggbApplet.getBase64();

				if (b64Img && b64Ggb) {
					CK_ELM.$.src = b64PngStart + b64Img
					CK_ELM.$.setAttribute('data-cke-saved-src', b64PngStart + b64Img)
					CK_ELM.$.setAttribute('data-ggb', b64Ggb)
					if (GGB_APP_HEIGHT) CK_ELM.$.setAttribute('data-app-height', GGB_APP_HEIGHT)
				}

				$modalGeogebra.modal('hide')
				return
			}
		})

		$modalGeogebra.on('shown.bs.modal', function() {
			ggbOptions.height = (window.innerHeight - 124 ) // 60 modal margin + 64 button
			GGB_APP = new GGBApplet(ggbOptions, true)
			GGB_APP.inject(ggbDomId);
			$body.addClass('modal-open-geogebra')
		})

		$modalGeogebra.on('hidden.bs.modal', function() {
			GEOGEBRA_STATE = false
			CK_EDITOR      = false
			CK_ELM         = false

			if (ggbOptions.ggbBase64) delete ggbOptions.ggbBase64
			if (ggbOptions.appletOnLoad) delete ggbOptions.appletOnLoad

			$modalGgb.empty().removeAttr('style')
			$body.removeClass('modal-open-geogebra').addClass('modal-open')
			$('#resizable-ggb').css('height', '')
		})

		$modalResizable.resizable({
			minHeight: 200,
			resize: function(ev, ui) {
				ui.size.width = ui.originalSize.width;
				window.ggbApplet.setSize(ui.originalSize.width, ui.size.height);
				GGB_APP_HEIGHT = ui.size.height
			}
		});

		$(window).on('load', ()=> WINDOW_IS_LOAD = true)
	}

	function initReplace() {

		const $modalQuestions = $('#modal-questions')

		$modalGeogebra = $modalQuestions.find('.modal-ggb-editor')

		function modalGgbHide() {
			if (CK_EDITOR) CK_EDITOR.focus()

			GEOGEBRA_STATE = false
			CK_EDITOR      = false
			CK_ELM         = false

			if (ggbOptions.ggbBase64) delete ggbOptions.ggbBase64
			if (ggbOptions.appletOnLoad) delete ggbOptions.appletOnLoad

			$body.removeClass('ggb-open')
			$modalGeogebra.addClass('d-n')
			$modalGeogebra.find('#'+ ggbDomId).empty().removeAttr('style')
			$modalGeogebra.find('#resizable-ggb').css('height', '')
		}

		$modalGeogebra.on('gp:modal-ggb-show', function() {
			$body.addClass('ggb-open')
			$modalGeogebra.removeClass('d-n')

			ggbOptions.height = 400
			GGB_APP = new GGBApplet(ggbOptions, true)
			GGB_APP.inject(ggbDomId)

			$modalGeogebra.find('#resizable-ggb').resizable({
				minHeight: 200,
				resize: function(ev, ui) {
					ui.size.width = ui.originalSize.width;
					window.ggbApplet.setSize(ui.originalSize.width, ui.size.height);
					GGB_APP_HEIGHT = ui.size.height
				}
			});
		})

		$modalGeogebra.find$$('modalGgbBtnCancel').on('click', modalGgbHide)

		$modalGeogebra.find$$('modalGgbBtnInsert').on('click', function() {

			if (GEOGEBRA_STATE === 'create') {
				const b64Img = ggbApplet.getPNGBase64(1, true, 72);
				const b64Ggb = ggbApplet.getBase64();
				const geoImage = getGeogebraImg(b64Img, b64Ggb)

				if (geoImage) {
					CK_EDITOR.insertHtml(geoImage)
				}
			}

			if (GEOGEBRA_STATE === 'edit') {
				const b64Img = ggbApplet.getPNGBase64(1, true, 72);
				const b64Ggb = ggbApplet.getBase64();

				if (b64Img && b64Ggb) {
					CK_ELM.$.src = b64PngStart + b64Img
					CK_ELM.$.setAttribute('data-cke-saved-src', b64PngStart + b64Img)
					CK_ELM.$.setAttribute('data-ggb', b64Ggb)
					if (GGB_APP_HEIGHT) CK_ELM.$.setAttribute('data-app-height', GGB_APP_HEIGHT)
				}
			}

			modalGgbHide()
		})

		$(window).on('load', ()=> WINDOW_IS_LOAD = true)
	}

	function init() {
		// initModal()
		initReplace()
	}

	init()

	// METHODS
	function showEditor({appName, editor, ckElm, openIn}) {
		if (!WINDOW_IS_LOAD) return

		ggbOptions.appName = appName
		GEOGEBRA_STATE     = ckElm ? 'edit' : 'create'
		CK_EDITOR          = editor
		CK_ELM             = ckElm || false

		if (ckElm) {
			ggbOptions.ggbBase64 = ckElm.$.getAttribute('data-ggb')
			if (ckElm.$.getAttribute('data-app-height')) {
				GGB_APP_HEIGHT = ckElm.$.getAttribute('data-app-height')

				ggbOptions.appletOnLoad = function() {
					console.log(1)
					window.ggbApplet.setHeight(GGB_APP_HEIGHT)
					$('#resizable-ggb').css('height', GGB_APP_HEIGHT)
				}
			}
		}

		// if (openIn === 'modal') $modalGeogebra.modal('show')
		$modalGeogebra.trigger('gp:modal-ggb-show')
	}

	return { showEditor }
}

function wirisEditor() {
	/*
	 Changed wiris ckeditor plugin
	 sources/public_html/app/js/vendor/ckeditor/plugins/ckeditor_wiris/core/core.js
	 :2701-2706 in function wrs_createModalWindow
	 :3015-3021 in function wrs_closeModalWindow
	*/

	function show(editor) {
		const $editor = $(editor)
		if (!$editor.length) return

		const $openModal = $('.modal.fade.in')
		const $target = $openModal.length ? $openModal.find$$('wirisEditor') : $$('wirisEditor')
		if (!$target.length) return

		$target.append($editor)
	}

	function close(editor) {
		const $editor = $(editor)
		if (!$editor.length) return

		const $openModal = $('.modal.fade.in')
		const $target = $openModal.length ? $openModal.find$$('wirisEditor') : $$('wirisEditor')
		if (!$target.length) return

		$target.empty()
	}

	return { show, close }
}

export { ckeditor, geogebra, wirisEditor }
